/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */
import React from 'react';
import PropTypes from "prop-types";
import { EuiDataGridHeaderCellWrapper } from './data_grid_header_cell_wrapper';
export var EuiDataGridControlHeaderCell = ({
  controlColumn,
  index,
  headerIsInteractive
}) => {
  const {
    headerCellRender: HeaderCellRender,
    width,
    id
  } = controlColumn;
  return <EuiDataGridHeaderCellWrapper className="euiDataGridHeaderCell--controlColumn" id={id} index={index} width={width} headerIsInteractive={headerIsInteractive}>
      <div className="euiDataGridHeaderCell__content">
        <HeaderCellRender />
      </div>
    </EuiDataGridHeaderCellWrapper>;
};
EuiDataGridControlHeaderCell.propTypes = {
  index: PropTypes.number.isRequired,
  controlColumn: PropTypes.shape({
    /**
       * Used as the React `key` when rendering content
       */
    id: PropTypes.string.isRequired,

    /**
       * Component to render in the column header
       */
    headerCellRender: PropTypes.elementType.isRequired,

    /**
       * Component to render for each row in the column
       */
    rowCellRender: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.func.isRequired]).isRequired,

    /**
       * Width of the column, uses are unable to change this
       */
    width: PropTypes.number.isRequired
  }).isRequired,
  headerIsInteractive: PropTypes.bool.isRequired
};

try {
  EuiDataGridControlHeaderCell.__docgenInfo = {
    tags: {},
    filePath: '/app/src/components/datagrid/body/header/data_grid_control_header_cell.tsx',
    description: '',
    displayName: 'EuiDataGridControlHeaderCell',
    methods: [],
    props: {
      index: {
        defaultValue: null,
        description: '',
        name: 'index',
        parent: {
          fileName: 'app/src/components/datagrid/data_grid_types.ts',
          name: 'EuiDataGridControlHeaderCellProps'
        },
        declarations: [{
          fileName: 'app/src/components/datagrid/data_grid_types.ts',
          name: 'EuiDataGridControlHeaderCellProps'
        }],
        required: true,
        type: {
          name: 'number'
        }
      },
      controlColumn: {
        defaultValue: null,
        description: '',
        name: 'controlColumn',
        parent: {
          fileName: 'app/src/components/datagrid/data_grid_types.ts',
          name: 'EuiDataGridControlHeaderCellProps'
        },
        declarations: [{
          fileName: 'app/src/components/datagrid/data_grid_types.ts',
          name: 'EuiDataGridControlHeaderCellProps'
        }],
        required: true,
        type: {
          name: 'EuiDataGridControlColumn'
        }
      },
      headerIsInteractive: {
        defaultValue: null,
        description: '',
        name: 'headerIsInteractive',
        parent: {
          fileName: 'app/src/components/datagrid/data_grid_types.ts',
          name: 'EuiDataGridControlHeaderCellProps'
        },
        declarations: [{
          fileName: 'app/src/components/datagrid/data_grid_types.ts',
          name: 'EuiDataGridControlHeaderCellProps'
        }],
        required: true,
        type: {
          name: 'boolean'
        }
      }
    },
    extendedInterfaces: ['EuiDataGridControlHeaderCellProps']
  };
} catch (e) {}